import React from 'react';
import BoroughFilter from './BoroughFilter';

const QuestionPriceList = ({neighborhoods, interpolators, formatters, changeProbabilityFocus, probability_focus, setActiveNeighborhood, top_space, borough_filter, setBoroughFilter, browser_width}) => {

  const prob_categories = ['Low', 'Medium', 'High'];
  const prob_categories_title = ['0-33%', '33-66%', '66-100%'];
  const category_step = 1/prob_categories.length;

  let prob_focus_index = false;
  if (probability_focus) prob_focus_index = Math.round(probability_focus * prob_categories.length - 1);

  const handleFocusClick = (value) => {
    if (value === probability_focus) {
      changeProbabilityFocus(false);
    } else {
      changeProbabilityFocus(value);
    }
  }

  const handleNeighborhoodClick = (neighborhood) => {
    setActiveNeighborhood(neighborhood.properties.neighborhood);
  }

  const neighborhood_item = (neighborhood) => {
    return <div
      className="SideListItem h5 hover relative flex pointer"
      onClick={handleNeighborhoodClick.bind(this, neighborhood)}
      style={{
        background: interpolators.chance(neighborhood.properties.probability),
      }}
      key={neighborhood.properties.neighborhood}
      >
        <div className="relative small-caps center"
          style={{
            width: '1.5rem',
            color: 'rgba(0,0,0,0.5)',
          }}
        >
          {formatters.borough_abbreviations[neighborhood.properties.borough]}
        </div>
        <div className="space-between flex grow-1">
          <div className=""
            style={{
              paddingLeft: '0.25rem'
            }}
          >
            {neighborhood.properties.neighborhood}
          </div>
          <div className="">
            {formatters.percentFormat(neighborhood.properties.probability)}
          </div>
        </div>
    </div>
  }

  // TODO: this should be cleaned up
  let poor_array = [];
  let good_array = [];
  let great_array = [];
  for (let neighborhood of neighborhoods) {
    if (neighborhood.properties.probability < 0.33) {
      poor_array.push(neighborhood);
    } else if (neighborhood.properties.probability < 0.66) {
      good_array.push(neighborhood);
    } else {
      great_array.push(neighborhood);
    }
  }
  let chance_arrays = [poor_array, good_array, great_array];

  let focus_index = false;
  let filtered_neighborhoods = neighborhoods;
  if (probability_focus) {
    focus_index = Math.round(probability_focus/category_step);
    filtered_neighborhoods = neighborhoods.filter((neighborhood) => neighborhood.properties.probability <= probability_focus && neighborhood.properties.probability > probability_focus - category_step ? true : false);
  }

  const bar_height = 202;

  let mobile = false;
  if (browser_width < 451) mobile = true;

  return (
    <div className="no-select">
      <div style={{paddingTop: bar_height}}>
        <div className="fixed top-left bg-white"
          style={{
            top: top_space,
            width: mobile ? '100%' : '360px',
            zIndex: '9'
          }}
        >
          <BoroughFilter
            borough_filter={borough_filter}
            setBoroughFilter={setBoroughFilter}
          />
          <div className="h6 mt1 px2 flex space-between uppercase">
            Filter List by Probability
            {probability_focus ? (
              <div className="pointer blue hover-underline" onClick={handleFocusClick.bind(this, false)}>Clear Filter</div>
            ) : null}
          </div>
          <div className="flex mt1 h5">
            {prob_categories.map((name,i) =>
              <div
                title={prob_categories_title[i]}
                className={"ProbFilterItem hover flex space-between relative px2 pointer py1 " + (i === prob_focus_index ? 'active' : '')}
                style={{
                  flex: 1,
                  background: interpolators.chance(category_step + (category_step * i))
                }}
                key={i}
                onClick={handleFocusClick.bind(this, (category_step + (category_step * i)))}
              >
                <div>{name}</div>
                <div className="ProbNumber" style={{color: 'rgba(0,0,0,0.5)'}}>{chance_arrays[i].length}</div>
              </div>
            )}
          </div>
          <div className="h6 px1 space-between py1 px2 mt1 uppercase flex">
            <div>Neighborhoods</div>
            <div
              style={{color: 'rgba(0,0,0,0.5)'}}
            >{filtered_neighborhoods.length}</div>
          </div>
        </div>
        <div className="fixed left-0"
          style={{
            width: mobile ? '100%' : '360px',
            top: top_space + bar_height,
            height: `calc(100% - ${top_space + bar_height}px`,
            overflowY: 'auto'
          }}
        >
          <div className="tnum">
            {filtered_neighborhoods.map((neighborhood) =>
              neighborhood_item(neighborhood)
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuestionPriceList;


/** WEBPACK FOOTER **
 ** ./src/components/QuestionPriceList.js
 **/